"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_slick_1 = __importDefault(require("react-slick"));
var edit_bundle_panel_1 = __importDefault(require("../edit-bundle/edit-bundle-panel"));
var bundle_card_1 = __importDefault(require("./components/bundle-card"));
var useMemo = React.useMemo;
exports.default = (function (_a) {
    var groupedSubscriptions = _a.groupedSubscriptions, customerData = _a.customerData;
    var numBundles = useMemo(function () { return groupedSubscriptions === null || groupedSubscriptions === void 0 ? void 0 : groupedSubscriptions.length; }, [groupedSubscriptions]);
    if (!numBundles) {
        return React.createElement("div", { className: 'margin-left-5' }, "You have no bundles");
    }
    if (numBundles === 1) {
        return React.createElement(edit_bundle_panel_1.default, { groupedSubscription: groupedSubscriptions[0], customerData: customerData, singleBundleUser: true });
    }
    var sliderSettings = {
        adaptiveHeight: true,
        dots: numBundles > 1,
        dotsClass: 'slick-dots-container slick-dots',
        arrows: false,
        centerMode: true,
        centerPadding: '3%',
        infinite: false,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'padding-top-3 padding-bottom-5 font-bold account-header' },
            React.createElement("img", { className: 'padding-right-3', src: window.accountApp.iconUrls.box }),
            "Your ",
            numBundles > 1 ? numBundles + ' bundles' : 'bundle'),
        React.createElement("div", { className: 'panel' },
            React.createElement(react_slick_1.default, __assign({}, sliderSettings), groupedSubscriptions === null || groupedSubscriptions === void 0 ? void 0 : groupedSubscriptions.map(function (groupedSubscription, i) {
                return (React.createElement("div", { className: 'card radius slick-slide', key: i },
                    React.createElement(bundle_card_1.default, { groupedSubscription: groupedSubscription })));
            })))));
});
